import { ListenerEvent as PackageListenerEvent } from '@carvana/merch-native';

enum VehicleListenerEvent {
  StartPreOrder = 'start_preorder',
  StartPurchase = 'start_purchase'
}

export const ListenerEvent = {
  ...VehicleListenerEvent,
  ...PackageListenerEvent
};

export type ListenerEventType = VehicleListenerEvent | PackageListenerEvent;
